<template>
    <div class="ui-enter">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ui-enter',

}

</script>

<style lang="scss">
    .ui-enter {
        // font-size: var(--small-size);

        p,
        h1,h2,h3,h4,
        ul, ol {
            margin: 0 0 1em 0;
        }
        ul,ol {
            margin-left: 1em;
        }
        h1,h2 {
            margin: 0 0 .5em 0;
        }

        h1:not(:first-child),h2:not(:first-child),h4:not(:first-child) {
            margin-top: var(--padding-x2);
        }

        h1 {
            font-size: var(--title-size);
            letter-spacing: var(--letter-spacing);
            line-height: 1.1;
            font-family: var(--title-font);
        }

        h2 {
            font-size: var(--title-size);
            letter-spacing: var(--letter-spacing);
            font-family: var(--title-font);
            line-height: 1.2;
        }

        h3,
        h4 {
            letter-spacing: var(--letter-spacing);
            font-family: var(--title-font);
            font-size: var(--large-size);
        }

        ol, ul {
            // margin-left: 2rem;

            li {
                margin: 0;
            }
        }

        ul {
            list-style-type: disc;
            list-style-position: outside;
            list-style-image: none;
        }

        ol {
            list-style-type: decimal;
            list-style-position: outside;
            list-style-image: none;
        }

        blockquote {
            right: -25rem;
            position: relative;
            margin: var(--padding-x3) 0;
            line-height: 1.2;
            width: 80%;
        }

        .gallery {
            display: none;
        }

        .wp-caption,
        .embed-image {
            display: block;
            margin: 0 0 var(--padding) 0;
            width: auto !important;

            img {
                display: block;
                width: 100%;
                height: auto;
                margin: 0;
            }

            .wp-caption-text {
                margin-top: .75rem;
                font-size: var(--tiny-size);
            }
        }
        
        img,
        iframe {
            max-width: 100%;
            max-height: 80vh;
            display: block;
            margin: 0 0 var(--padding) 0;
            width: auto;
            height: auto;
        }

        .embed-video {
            display: block;
            margin: var(--padding) 0;
            width: auto !important;
            position: relative;

            &::before {
                display: block;
                content: '';
                padding-top: 56.2%;
            }

            iframe {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
        }

        .columns-container {
            display: flex;
            margin: 0 calc(var(--padding) * -1);
            // font-size: var(--small-size);
            width: calc(var(--page-width) - var(--padding-x2)) ;

            &.columns-2 .gca-column {
                width: 50%;
            }

            &.columns-3 .gca-column {
                width: 33.33%;
            }

            &.columns-4 .gca-column {
                width: 25%;
            }
        }

        .gca-column {
            margin: 0 0 var(--padding-x2) 0;
            padding: 0 var(--padding);

            // &.one-half {
            //     width: 50%;
            //     box-sizing: border-box;
            //     padding-right: var(--padding-50);

            //     & + .one-half {
            //         padding-right: 0;
            //         padding-left: var(--padding-50);
            //     }
            // }

            & + h2,
            & + h3,
            & + h4,
            & + ol,
            & + ul,
            & + p,
            & + br {
                clear: both;
            }
        }

        .link-button {
            display: block;
            line-height: 1;
            border: var(--line-2) solid;
            text-align: center;
            cursor: pointer;
            padding: 1rem 2rem;
                
            &:hover {
                color: white;
                background-color: black;
            }

        }
    }

    .ui-enter {
        & > .box {
            margin: 0 27rem var(--padding-x2) 0;
            max-width: 70rem;
        }
    }

    @media only screen and (max-width: 767px) {
        .ui-enter {

            ul,ol {
                margin-left: 5rem;
            }

            .columns-container {
                display: block;
                margin: 0;
                width: auto ;

                &.columns-2 .gca-column {
                    width: 100%;
                    margin: var(--padding) 0;
                    padding: 0;
                }

                &.columns-3 .gca-column {
                    width: 100%;
                    margin: var(--padding) 0;
                    padding: 0;
                }

                &.columns-4 .gca-column {
                    width: 100%;
                    margin: var(--padding) 0;
                    padding: 0;
                }
            }

        }
        .ui-enter {
            & > .box {
                margin: 0 0 var(--padding-x2) 0;
                max-width: 100%;
            }

            div, span {
                max-width: 100%;
            }
        }
    }

    // .inner .ui-enter {
    //     & > .box {
    //         margin: 0 19rem var(--padding-x2) 0;
    //         font-size: var(--small-size);
    //     }

        

    //     a {
    //         border-bottom: 1px solid;
    //     }

    //     .wp-caption,
    //     .embed-image {
    //         margin: 0  -19rem var(--padding) 0;

    //         & + h4 {
    //             margin-top: 0;
    //         }
    //     }
    // }
</style>